var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 7.58464C6.96617 7.58464 7.74967 6.80113 7.74967 5.83464C7.74967 4.86814 6.96617 4.08464 5.99967 4.08464C5.03318 4.08464 4.24967 4.86814 4.24967 5.83464C4.24967 6.80113 5.03318 7.58464 5.99967 7.58464Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 12.8346C8.33301 10.5013 10.6663 8.41196 10.6663 5.83464C10.6663 3.25731 8.577 1.16797 5.99967 1.16797C3.42235 1.16797 1.33301 3.25731 1.33301 5.83464C1.33301 8.41196 3.66634 10.5013 5.99967 12.8346Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.d1103310bf893b07f64237fcab278a1b.svg";
export { ForwardRef as ReactComponent };